import { DENETIM_BULGU_TURLERI, type DenetimBulgu, type DenetimBulguTuru, type DenetimFindings } from "@/api/denetim";

import { SIDDET_BY_TUR, type Siddet } from "./severity";

export interface DenetimBulguRow extends DenetimBulgu {
  /** `${tur}-${tur-ici-sira}` — SortableTable rowKey icin (tek argumanla cagrilir, indeks disaridan verilemez). */
  id: string;
  tur: DenetimBulguTuru;
  siddet: Siddet;
}

/**
 * Backend `findings` bulgu turune gore GRUPLANMIS doner (bkz.
 * app/audit/catalog.py katalog_denetimi `bulgular`); tek tabloda gosterebilmek
 * icin (tur/urun/aciklama/siddet sutunlari + siddet filtresi) tek duz listeye
 * acilir. Bilinmeyen bir tur (`findings` anahtari `DENETIM_BULGU_TURLERI`'nde
 * yoksa) sessizce atlanir — motor kural genisletilirse burasi guncellenmeli.
 */
export function flattenFindings(findings: DenetimFindings): DenetimBulguRow[] {
  const rows: DenetimBulguRow[] = [];
  for (const tur of DENETIM_BULGU_TURLERI) {
    const bulgular = findings[tur] ?? [];
    bulgular.forEach((bulgu, i) => {
      rows.push({ ...bulgu, id: `${tur}-${i}`, tur, siddet: SIDDET_BY_TUR[tur] });
    });
  }
  return rows;
}

export function filterBySiddet(rows: DenetimBulguRow[], siddet: Siddet | "hepsi"): DenetimBulguRow[] {
  if (siddet === "hepsi") return rows;
  return rows.filter((r) => r.siddet === siddet);
}
